import { motion } from 'framer-motion';
import { useMemo } from 'react';

const Drop = ({ x, delay, duration, size }) => (
  <motion.div
    className="gm-rain-drop"
    style={{ left: `${x}%`, top: -20 }}
    initial={{ y: -20, opacity: 0 }}
    animate={{ y: ['0vh', '105vh'], opacity: [0, 0.6, 0.6, 0] }}
    transition={{ duration, delay, repeat: Infinity, ease: 'linear' }}
  >
    <div
      style={{
        width: size,
        height: size * 3,
        borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%',
        background: 'hsl(68, 100%, 50%)',
        filter: `blur(0.3px) drop-shadow(0 0 ${size + 1}px hsl(68 100% 50% / 0.4))`,
      }}
    />
  </motion.div>
);

export const BackgroundRain = () => {
  const drops = useMemo(
    () =>
      Array.from({ length: 30 }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        delay: Math.random() * 4,
        duration: 1 + Math.random() * 1,
        size: 1.5 + Math.random() * 2,
      })),
    []
  );

  return (
    <div className="gm-rain-container">
      {drops.map((d) => (
        <Drop key={d.id} x={d.x} delay={d.delay} duration={d.duration} size={d.size} />
      ))}
    </div>
  );
};
